import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights, spacings, colors, responsiveBreakPoints } from '@styles/DesignVariables';

const { maxTablet } = responsiveBreakPoints;

interface ListTextProps {
	$isLast?: boolean;
	$fontSize?: string;
	$lineHeight?: string;
}
interface ListHeadingProps {
	$color?: string;
}

export const ListWrapper = styled.ul`
	display: flex;
	flex-direction: column;
`;

export const ListHeading = styled.h3<ListHeadingProps>`
	font-size: ${fontSizes.heroBoxHeading};
	line-height: 20px;
	font-weight: ${fontWeights.bold};
	color: ${({ $color }) => $color || colors.paragraphText};
	margin-bottom: ${spacings.s16};
`;

export const ListItem = styled.li`
	display: flex;
	align-items: flex-start;

	svg {
		height: 16px;
		width: 16px;
		flex-shrink: 0;
	}
`;

export const ListText = styled.p<ListTextProps>`
	display: flex;
	gap: 8px;
	margin-bottom: ${({ $isLast }) => ($isLast ? '0px' : '8px')};
	font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : fontSizes.tinyParagraph)};
	line-height: ${({ $lineHeight }) => ($lineHeight ? $lineHeight : lineHeights.tinyParagraph)};
	color: ${colors.paragraphText};
	@media screen and (${maxTablet}) {
		font-size: 14px;
		line-height: 16px;
	}
`;
